export default __webpack_public_path__ + "static/media/mesencephalon_mask.c3e26ac9.png";